import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.css']
})
export class ConfirmPopupComponent {

  public title: string;

  constructor(
    protected dialogRef: NbDialogRef<ConfirmPopupComponent>,
    private translate: TranslateService
  ) { 
    this.title = "";
  }

  cancel() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close(true);
  }  

}
